export default class EvaluationListDto {
  listId;
  listName;
  numOfGrade;
  abolitionFlg;
  gradeRange;

  constructor(data) {
    this.listId = data.listId;
    this.listName = data.listName;
    this.numOfGrade = data.numberOfGrades;
    this.gradeRange = data.gradeRange;
    this.abolitionFlg = data.abolition;
  }
}
